import { render, staticRenderFns } from "./Pos_bill_recall.vue?vue&type=template&id=38c2e400&scoped=true&"
import script from "./Pos_bill_recall.vue?vue&type=script&lang=js&"
export * from "./Pos_bill_recall.vue?vue&type=script&lang=js&"
import style0 from "./Pos_bill_recall.vue?vue&type=style&index=0&id=38c2e400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c2e400",
  null
  
)

export default component.exports